import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaPaperPlane, FaLinkedin, FaGithub, FaEnvelope, FaPhone } from "react-icons/fa";
import { SiLeetcode } from "react-icons/si";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;
    const body = `Name: ${name}%0D%0AEmail: ${email}%0D%0A%0D%0AMessage:%0D%0A${message}`;
    window.location.href = `mailto:koparkaryash41@gmail.com?subject=${encodeURIComponent(subject)}&body=${body}`;
  };

  return (
    <Container fluid className="contact-section">
      <Container>
        <h1 className="project-heading">
          Get In <strong className="purple">Touch</strong>
        </h1>
        <p style={{ color: "white", textAlign: "center", marginBottom: "40px" }}>
          Feel free to reach out for any collaboration or query
        </p>

        <Row style={{ justifyContent: "center" }}>
          <Col md={6}>
            <div className="contact-form-container">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="contact-form-group">
                  <Form.Label className="contact-label">Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    className="contact-input"
                    required
                  />
                </Form.Group>

                <Form.Group className="contact-form-group">
                  <Form.Label className="contact-label">Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    className="contact-input"
                    required
                  />
                </Form.Group>

                <Form.Group className="contact-form-group">
                  <Form.Label className="contact-label">Subject</Form.Label>
                  <Form.Control
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    className="contact-input"
                    required
                  />
                </Form.Group>

                <Form.Group className="contact-form-group">
                  <Form.Label className="contact-label">Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your Message"
                    className="contact-input"
                    rows={5}
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="contact-submit-btn">
                  <FaPaperPlane /> Send Email
                </Button>
              </Form>
            </div>
          </Col>

          <Col md={5} className="contact-info-section">
            <div className="contact-info-card">
              <h3 className="contact-info-title">Contact Info</h3>
              
              <div className="contact-info-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <p className="contact-info-label">Email</p>
                  <a href="mailto:koparkaryash41@gmail.com" className="contact-link">koparkaryash41@gmail.com</a>
                </div>
              </div>

              <div className="contact-info-item">
                <FaPhone className="contact-icon" />
                <div>
                  <p className="contact-info-label">Phone</p>
                  <a href="tel:+919373782519" className="contact-link">+91-9373782519</a>
                </div>
              </div>

              <div className="contact-social-links">
                <h4 className="social-links-title">Connect With Me</h4>
                <div className="contact-social-icons">
                  <a href="https://github.com/Yashh0222" target="_blank" rel="noreferrer" className="contact-social-icon">
                    <FaGithub />
                  </a>
                  <a href="https://www.linkedin.com/in/yash-koparkar-8307a128a/" target="_blank" rel="noreferrer" className="contact-social-icon">
                    <FaLinkedin />
                  </a>
                  <a href="https://leetcode.com/yash_koparkar" target="_blank" rel="noreferrer" className="contact-social-icon">
                    <SiLeetcode />
                  </a>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Contact;